module.exports = __webpack_public_path__ + "img/P150T_weapon_63.d046d448.png";